module.exports = __webpack_public_path__ + "static/media/checkbox-1.94a3225c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkbox-1.svg
// module id = ./src/assets/images/checkbox-1.svg
// module chunks = 0